import { render, staticRenderFns } from "./EgovProvisionsModal.vue?vue&type=template&id=46b52a51&"
import script from "./EgovProvisionsModal.vue?vue&type=script&lang=js&"
export * from "./EgovProvisionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports